module.exports = __webpack_public_path__ + "static/media/25.dafdcbbd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/units/25.svg
// module id = 398
// module chunks = 14